import { postApi } from 'api/fetchApi'
import { paths } from 'api/generated/mute_user'

type MethodMute = paths['/users/mute']['post']
type RequestMute = MethodMute['parameters']['body']['body']
type ResponseMute = MethodMute['responses']['204']

type MethodUnmute = paths['/users/unmute']['post']
type RequestUnmute = MethodUnmute['parameters']['body']['body']
type ResponseUnmute = MethodUnmute['responses']['204']

export const muteProfileApi = (userIds: number[]) => {
  return postApi<ResponseMute, RequestMute>('/users/mute', {
    userIds,
  })
}

export const unmuteProfileApi = (userIds: number[]) => {
  return postApi<ResponseUnmute, RequestUnmute>('/users/unmute', {
    userIds,
  })
}
